import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "card" };
const _hoisted_2 = { style: { "display": "flex", "flex-direction": "row", "gap": "20px" } };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h3", { class: "headline" }, "Website", -1);
const _hoisted_4 = { class: "website-details-link" };
const _hoisted_5 = ["href"];
const _hoisted_6 = { style: { "padding": "20px 20px 0px 20px" } };
const _hoisted_7 = { class: "warning-anomalie-details-list" };
const _hoisted_8 = { class: "website-details grid flex-justify-center" };
const _hoisted_9 = { class: "col-12 md:col-4" };
const _hoisted_10 = { class: "col-12 md:col-4" };
const _hoisted_11 = { class: "flex-justify-center" };
const _hoisted_12 = { class: "col-12 md:col-4" };
const _hoisted_13 = { class: "col-12 md:col-4" };
const _hoisted_14 = { class: "col-12 md:col-4" };
const _hoisted_15 = { class: "col-12 md:col-4" };
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { class: "justified-right-in-line-action-buttons" };
import OneDeskMarketColumn from "@/components/molecules/OneDeskMarketColumn.vue";
import Button from "primevue/button";
import Tag from "primevue/tag";
import { divisionList, zoneList } from "@/shared/utils/website.constant";
import OneDeskWarningBlock from "@/components/atoms/OneDeskWarningBlock.vue";
import AnomaliesTexts from "@/shared/json/anomaliesText.json";
import WpModalTemplate from "@/views/WebPageTests/WpModalTemplate.vue";
import { ref } from "vue";
import Divider from "primevue/divider";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WebsiteInfo',
    props: {
        websiteDetails: {},
        siteFrameworkBackGroundColor: {},
        displaySiteFramework: {}
    },
    setup(__props) {
        const { websiteDetails, siteFrameworkBackGroundColor, displaySiteFramework } = __props;
        const wpType = ref("");
        const isTemplateModalOpen = ref(false);
        const webPageTestCommands = [
            {
                label: "Perform load test",
                slug: "load-testing",
                icon: "pi pi-chart-line",
                severity: "warning",
                outlined: true,
                code: "wp1"
            },
            {
                label: "Perform performance test",
                slug: "page-performance",
                icon: "pi pi-chart-bar",
                severity: "primary",
                outlined: false,
                code: "wp4"
            },
            {
                label: "Perform accessibility test",
                slug: "accessibility",
                icon: "pi pi-eye",
                severity: "primary",
                outlined: false,
                code: "wp6"
            },
            {
                label: "Perform SEO test",
                slug: "seo",
                icon: "pi pi-search",
                severity: "warning",
                outlined: true,
                code: "wp8"
            },
        ];
        const openWpModal = (code) => {
            isTemplateModalOpen.value = true;
            wpType.value = code;
            const body = document.body;
            body.style.height = "100vh";
            body.style.overflowY = "hidden";
        };
        const ecommInfos = (value) => {
            if (value.toLowerCase().includes("yes"))
                return "Yes";
            else
                return value;
        };
        const getZoneName = (zone) => {
            return zoneList.find((z) => z.value === zone)?.label ?? zone;
        };
        const getDivisionName = (division) => {
            return divisionList.find((d) => d.value === division)?.label ?? division;
        };
        const getAnomalyText = (item) => {
            switch (item) {
                case "DNS_STATUS_KO":
                    return AnomaliesTexts.DNS_STATUS_KO;
                case "CLOUDFLARE_STATUS_KO":
                    return AnomaliesTexts.CLOUDFLARE_STATUS_KO;
                case "PROTOCOL_NOT_SECURE":
                    return AnomaliesTexts.PROTOCOL_NOT_SECURE;
                case "SITE_DEAD":
                    return AnomaliesTexts.SITE_DEAD;
                default:
                    return item;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("a", {
                            href: _ctx.websiteDetails.fullSiteName,
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }, [
                            _createVNode(OneDeskButton, {
                                severity: "primary",
                                label: _ctx.websiteDetails.fullSiteName,
                                style: { "margin-right": "5px" },
                                icon: "pi pi-link"
                            }, null, 8, ["label"])
                        ], 8, _hoisted_5)
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    (_ctx.websiteDetails.anomalies && _ctx.websiteDetails.anomalies.length > 0)
                        ? (_openBlock(), _createBlock(OneDeskWarningBlock, {
                            key: 0,
                            class: "warning-anomalie-details"
                        }, {
                            content: _withCtx(() => [
                                _createElementVNode("div", null, [
                                    _createTextVNode(" This website contains anomalies : "),
                                    _createElementVNode("ul", _hoisted_7, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.websiteDetails.anomalies, (item) => {
                                            return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(getAnomalyText(item)), 1));
                                        }), 128))
                                    ])
                                ])
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, [
                            _createVNode(_unref(Tag), {
                                style: { "margin-right": "5px" },
                                severity: "secondary",
                                icon: "pi pi-inbox",
                                value: "Zone"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.websiteDetails.zone == "_INTL"
                                ? _ctx.websiteDetails.displayMarket
                                : getZoneName(_ctx.websiteDetails.zone)), 1)
                        ]),
                        _createElementVNode("span", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(_unref(Tag), {
                                    style: { "margin-right": "5px" },
                                    severity: "secondary",
                                    icon: "pi pi-globe",
                                    value: "Market"
                                }),
                                _createVNode(OneDeskMarketColumn, {
                                    "market-code": _ctx.websiteDetails.displayMarket
                                }, null, 8, ["market-code"])
                            ])
                        ]),
                        _createElementVNode("span", _hoisted_12, [
                            _createVNode(_unref(Tag), {
                                style: { "margin-right": "5px" },
                                severity: "secondary",
                                icon: "pi pi-flag",
                                value: "Division"
                            }),
                            _createTextVNode(_toDisplayString(getDivisionName(_ctx.websiteDetails.division)), 1)
                        ]),
                        _createElementVNode("span", _hoisted_13, [
                            _createVNode(_unref(Tag), {
                                style: { "margin-right": "5px" },
                                severity: "secondary",
                                icon: "pi pi-th-large",
                                value: "Site Type"
                            }),
                            _createTextVNode(_toDisplayString(_ctx.websiteDetails.siteType), 1)
                        ]),
                        _createElementVNode("span", _hoisted_14, [
                            _createVNode(_unref(Tag), {
                                style: { "margin-right": "5px" },
                                severity: "secondary",
                                icon: "pi pi-filter",
                                value: "Platform"
                            }),
                            _createElementVNode("span", {
                                class: "platform-badge",
                                style: _normalizeStyle({ backgroundColor: _ctx.siteFrameworkBackGroundColor })
                            }, _toDisplayString(_ctx.displaySiteFramework), 5)
                        ]),
                        _createElementVNode("span", _hoisted_15, [
                            _createVNode(_unref(Tag), {
                                style: { "margin-right": "5px" },
                                severity: "secondary",
                                icon: "pi pi-shopping-cart",
                                value: "E-Commerce"
                            }),
                            (_ctx.websiteDetails.ecomm !== '_' && _ctx.websiteDetails.ecomm !== null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(ecommInfos(_ctx.websiteDetails.ecomm)), 1))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]),
                _createVNode(_unref(Divider)),
                _createElementVNode("div", _hoisted_17, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(webPageTestCommands, (command) => {
                        return _createVNode(_unref(Button), {
                            onClick: ($event) => (openWpModal(command.code)),
                            key: command.slug,
                            label: command.label,
                            icon: command.icon,
                            severity: command.severity,
                            outlined: command.outlined
                        }, null, 8, ["onClick", "label", "icon", "severity", "outlined"]);
                    }), 64))
                ]),
                _createVNode(WpModalTemplate, {
                    isOpen: isTemplateModalOpen.value,
                    "onUpdate:isOpen": _cache[0] || (_cache[0] = ($event) => ((isTemplateModalOpen).value = $event)),
                    "wp-type": wpType.value,
                    "full-url": _ctx.websiteDetails.fullSiteName,
                    "site-name": _ctx.websiteDetails.siteName,
                    "url-id": _ctx.websiteDetails.id,
                    brand: _ctx.websiteDetails.brand,
                    market: _ctx.websiteDetails.displayMarket
                }, null, 8, ["isOpen", "wp-type", "full-url", "site-name", "url-id", "brand", "market"])
            ]));
        };
    }
});
